import axios from 'axios'
import qs from 'qs'
// import store from '../store'
// 加载进度条
// import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {Message} from 'element-ui'
import {getUrlParams, getStoreByKey} from '../utils/index'
// 页面初始化进度条
// NProgress.configure({
//     // 是否显示ico
//     showSpinner: false,
//     // 关闭递增
//     trickle: false,
//     // 初始化时的最小百分比
//     minimum: 0.3
// })

const http = axios.create({
    // 数据接口 Url 地址前缀
    // baseURL: store.getters.config('baseUrl'),
    // 请求超时时间
    timeout: 5000,
    headers: {
        'Content-type': 'application/x-www-form-urlencoded'
    }
})

/**
 * http 请求处理
 */
http.interceptors.request.use(
    config => {
    // http 请求进度条 start
        // NProgress.start()
        // 请求参数
        const url = location.href
        // 内嵌页面登陆验证
        let __TOKEN = getUrlParams(url)['token'] || ''
        if (__TOKEN) {
            config.headers.Authorization = __TOKEN
        }
        // 优先取登陆完成后给的jwt字段
        const __JWT = getStoreByKey('HD_PTM_USERINFO', 'jwt')
        if (__JWT) {
            config.headers.Authorization = __JWT
        }
        config.method === 'post' ? (config.data = qs.stringify({ ...config.data })) : (config.params = { ...config.params })
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

/**
 * http 响应处理
 */
http.interceptors.response.use(
    response => {
    // http 请求进度条 end
        // NProgress.done()
        const res = response.data
        if (res.code === 200 || res.code === 410) {
            return res.data
        } else if (res.code === 403) {
            Message.closeAll()
            Message({type: 'error', message: response.data.msg})
            setTimeout(() => {
                // 生产环境
                window.location.href = location.protocol + '//' + location.hostname + '/ptm-client/#/login'
                // 本地
                // window.location.href = '/#/login'
            }, 500)
        } else if ([411, 412].indexOf(res.code) !== -1) {
            // 处理已注册状态
            return res
        } else {
            Message({type: 'error', message: response.data.msg ? response.data.msg : '操作失败'})
            return null
        }
    },
    error => {
    // http 请求进度条 end
        // NProgress.done()
        // 接口异常处理
        if (error.message.indexOf('timeout') !== -1) {
            Message.error('网络超时')
        } else if (error.message === 'Network Error') {
            Message.error('网络连接错误')
        } else if (error.message.indexOf('404') !== -1) {
            Message.error('接口地址不存在')
        }
        return Promise.reject(error)
    }
)
// 暴露指定请求方式
export const get = (url, option) => {
    return http.get(url, option)
}

export const post = (url, option) => {
    return http.post(url, option)
}



// WEBPACK FOOTER //
// ./src/request/http.js